import http from './http';

export async function adminListUsers() {
  const size = 100;
  let page = 0;
  let total = 0;
  const items = [];
  do {
    const { data } = await http.get('/api/admin/users/page', { params: { page, size } });
    const batch = data && data.items ? data.items : [];
    total = Number(data && data.total ? data.total : batch.length);
    items.push(...batch);
    page++;
  } while (items.length < total && page < 200);
  return items;
}

export async function adminCreateUser(payload) {
  const { data } = await http.post('/api/admin/users', payload);
  return data;
}

export async function adminResetPassword(id, payload) {
  const { data } = await http.post(`/api/admin/users/${id}/reset-password`, payload);
  return data;
}

export async function adminSetUserEnabled(id, payload) {
  const { data } = await http.post(`/api/admin/users/${id}/enabled`, payload);
  return data;
}

export async function adminSoftDeleteUser(id) {
  const { data } = await http.post(`/api/admin/users/${id}/soft-delete`);
  return data;
}

export async function adminKickUser(id) {
  const { data } = await http.post(`/api/admin/users/${id}/kick`);
  return data;
}

export async function adminUnlockUser(id) {
  const { data } = await http.post(`/api/admin/users/${id}/unlock`);
  return data;
}

export async function adminSetCaseNoPrefix(id, payload) {
  const { data } = await http.post(`/api/admin/users/${id}/case-no-prefix`, payload);
  return data;
}

export async function adminListTeams() {
  const { data } = await http.get('/api/admin/users/teams');
  return data;
}

export async function adminCreateTeam(payload) {
  const { data } = await http.post('/api/admin/users/teams', payload);
  return data;
}

export async function adminSetTeamMembers(id, payload) {
  const { data } = await http.post(`/api/admin/users/teams/${id}/members`, payload);
  return data;
}

export async function adminDeleteTeam(id) {
  const { data } = await http.post(`/api/admin/users/teams/${id}/delete`);
  return data;
}

export async function adminListTasks() {
  const { data } = await http.get('/api/admin/tasks');
  return data;
}

export async function adminPageTasks(params) {
  const { data } = await http.get('/api/admin/tasks/page', { params });
  return data;
}

export async function adminCreateTask(payload) {
  const { data } = await http.post('/api/admin/tasks', payload);
  return data;
}

export async function adminTaskReceipts(id) {
  const { data } = await http.get(`/api/admin/tasks/${id}/receipts`);
  return data;
}

export async function adminListAnnouncements() {
  const { data } = await http.get('/api/admin/announcements');
  return data;
}

export async function adminPageAnnouncements(params) {
  const { data } = await http.get('/api/admin/announcements/page', { params });
  return data;
}

export async function adminCreateAnnouncement(payload) {
  const { data } = await http.post('/api/admin/announcements', payload);
  return data;
}

export async function adminAnnouncementStats(id) {
  const { data } = await http.get(`/api/admin/announcements/${id}/stats`);
  return data;
}

export async function adminGetBadges() {
  const { data } = await http.get('/api/admin/badges');
  return data;
}

export async function adminMarkAnnouncementSeen(id) {
  const { data } = await http.post(`/api/admin/announcements/${id}/seen`);
  return data;
}

export async function adminMarkTaskSeen(id) {
  const { data } = await http.post(`/api/admin/tasks/${id}/seen`);
  return data;
}

export async function adminCloseTask(id) {
  const { data } = await http.post(`/api/admin/tasks/${id}/close`);
  return data;
}

// System management
export async function adminPurgeAll(payload) {
  const { data } = await http.post('/api/admin/system/purge-all', payload);
  return data;
}

export async function adminGetPurgeStatus(jobId) {
  const { data } = await http.get(`/api/admin/system/purge-all/${jobId}`);
  return data;
}
